export function useFirm(): { idt: number; name: string; email?: string } | null {
    const stored = localStorage.getItem('selectedFirm');
    if (!stored) return null;

    try {
        return JSON.parse(stored);
    } catch {
        return null;
    }
}
